module.exports = __webpack_public_path__ + "trutrutruches.gif?a9853c39a1be035e2d164da1074f989a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trutrutruches.gif
// module id = 139
// module chunks = 0